import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { YaloService } from '@core/yalo';
import { PopoverController } from '@ionic/angular';
import { NotificacionesService } from './services/notificaciones.service';
import { CategoriasNotificacionModel } from '@pages/notificaciones/notificaciones.types';

@Component({
  selector: 'app-notificaciones',
  templateUrl: './notificaciones.component.html',
  styleUrls: ['./notificaciones.component.scss'],
})
export class NotificacionesComponent implements OnInit {
  readonly notificaciones$ = this._yalo.notificaciones$;
  categorias: CategoriasNotificacionModel[] = []//CategoriasNotificacion;

  constructor(
    public readonly popoverController: PopoverController,
    private _yalo: YaloService,
    private _router: Router,
    private _notificacionesService: NotificacionesService
  ) { }

  ngOnInit() {
    this._notificacionesService.getTiposNotificaciones()
    .subscribe(tipos => {
      this.categorias = tipos;
    });
  }

  onNotificationClick(CodNotificacion: number) {
    this._yalo.selectNotification(CodNotificacion);
    this.popoverController.dismiss();
    this._router.navigate(['/notificaciones']);
  }

  getCategory = (id: number) => this.categorias.find(x => x.CodCategoria == id) ?? null;

}
